import { Component } from '@angular/core';

@Component({
  selector: 'error',
  templateUrl: '../views/page-sections/error.html'
})

export class ErrorComponent{
  public title: string;

  constructor()
  {
    this.title = "Error Page";
  }

  ngOnInit()
  {
    console.log("Error Component initialized");
  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/error.component.ts